<template>
  <section class="section container pt-0">
    <div class="title is-4">{{ $t("trip request") }}</div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("your name") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.name" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("phone") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.phone" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("email") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.email" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("origin") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.origin" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("destination") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.destination" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("date") }}</label>
          <div class="control">
            <input class="input" type="datetime-local" v-model="meta.date" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("number of passengers") }}</label>
          <div class="control">
            <input
              class="input"
              type="number"
              v-model="meta.passenger_number"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("luggage number") }}</label>
          <div class="control">
            <input class="input" type="number" v-model="meta.luggage_number" />
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <div
      class="button is-medium is-primary is-rounded is-pulled-right"
      @click="request_ride"
    >
      <span class="icon">
        <i class="fa fa-car"></i>
      </span>
      <span>{{ $t("request trip") }}</span>
    </div>
  </section>
</template>

<script>
import { put, generate_error_message_text, success_message } from "@/utils";
import moment from "moment";
// import InventoryMovementDatatable from "./inventory_movement_datatable/Index.vue";

export default {
  name: "InventoryMovements",
  components: {
    // InventoryMovementDatatable,
  },
  data() {
    return {
      meta: {
        origin: "San Pedro",
        destination: "Guatemala",
        name: "Luis Robledo",
        phone: "52183947",
        email: "strato0100@gmail.com",
        date: "2024-11-15T10:00",
        passenger_number: "1",
        luggage_number: "1",
      },
      error: "",
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    request_ride() {
      let v = this;
      v.error = "";
      let data = { ...v.meta };
      data.date = moment(data.date);
      put("/trip/request", data)
        .then(() => {
          success_message(
            v.$t("your trip has been requested, we will contact you soon")
          );
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        })
        .catch((err) => {
          console.error(err);
          v.error = generate_error_message_text(err);
        });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
